
export default {
  name: 'BusinessSupportSlice',
  props: ['slice'],
  computed: {
    locale(){
      return this.$i18n.locale
    }
  },
  data() {
    return {
      title: {
        en: `Exclusive for corporate customers.`,
        it: `Esclusivo per le aziende.`,
        de: `Exklusiv für Unternehmen.`
      },
      items: [
        {
          text: {
            en: `Dedicated <br>Dashboard`,
            it: `Dashboard <br>dedicata`,
            de: `Spezielles <br>Dashboard`,
          },
          icon: `https://vitesy.cdn.prismic.io/vitesy/101feba4-3bfd-4680-ac7d-c4f74cfa2f5b_marketing-icon.svg`
        },
        {
          text: {
            en: `Marketing <br>materials`,
            it: `Materiali <br>marketing`,
            de: `Marketing-Materialien`,
          },
          icon: `https://vitesy.cdn.prismic.io/vitesy/e2e77dc3-7c8a-4041-ae5e-858de5ad458e_dashboard-icon.svg`
        },
        {
          text: {
            en: `Dedicated<br>offers`,
            it: `Offerte<br>dedicate`,
            de: `Spezifische<br>Angebote`,
          },
          icon: `https://vitesy.cdn.prismic.io/vitesy/f488c10b-5157-42a8-8ee2-0440f1586445_contact-us-2-icon.svg`
        },
        {
          text: {
            en: `Personal<br>support`,
            it: `Supporto<br>personale`,
            de: `Persönliche<br>Unterstützung`,
          },
          icon: `https://vitesy.cdn.prismic.io/vitesy/f4bce635-3547-4a1e-b6af-0efda7a20bab_contact-us-4-icon.svg`
        },
      ]
    }
  }
}
